import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/case-studies/ether/solution_back.webp";

function Solutionether() {
  return (
    <section
      className="solution_ether p-100 back_dark text_white"
      style={{ backgroundImage: `url(${BgImg})`, backgroundColor: "#141826" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className=" my-auto">
            <h2>Tekrevol’s Solution</h2>
            <p>
              Considering that the Initial requirements of the concise and
              precise brief provided by the client, it was clear to Tekrevol
              that engaging a dedicated team comprised of specialized resources
              in design, blockchain, database and Unity 3D would be the best way
              to stabilize and scale.
            </p>
            <p>
              We were excited to embrace the challenge and started with first
              identifying, isolating and fixing the existing issues with the
              backend architecture. We then moved on to the graphical, UI/UX
              enhancements and improvements, subsequent to which the backend and
              game development resources initiated work on such features such as
              Meta Mask wallet integration (for seamlessly linking player
              accounts with the Ethereum Network), real-time notifications, and
              battle environments connected to Blockchain environments.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center offset-xl-1 offset-lg-1"
          >
            <div className="solution_ether_img">
              <StaticImage
                src="../../../images/case-studies/ether/solution_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={902}
                height={662}
              />
            </div>
          </Col>
        </Row>
        <Row className="padd_top">
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="text-center m-auto"
          >
            <h2>The Result</h2>
            <p>
              Per the client’s initial vision, TekRevol successfully finished
              and deployed a player-focused game, with a seamless integration to
              Blockchain fundamentals and continues to work the scaling aspects,
              single player (AI) and additional concepts that had to be put on
              hold in order to stabilize the game. The future concepts include
              more Blockchain integration, game mechanics and the ability for
              players to seamlessly claim NFT’s through the app interfaces.
            </p>
            <p>
              The Ether Legends game is interactive, and user friendly with
              catchy characters, artwork and appealing environments that elevate
              the gaming experience, with player owned assets and a play to earn
              ecosystem.
            </p>
            <div className="result_img">
              <StaticImage
                src="../../../images/case-studies/ether/result_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={1201}
                height={607}
              />
            </div>
          </Col>
        </Row>
        <Row className="padd_top">
          <Col
            xs={12}
            md={5}
            lg={5}
            xl={5}
            xxl={5}
            className="text-center resp_order"
          >
            <StaticImage
              src="../../../images/case-studies/ether/magical_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={443}
              height={565}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="offset-xl-2 offset-lg-2 offset-md-1 my-auto"
          >
            <h2>Will You Join Us In A Magical Journey?</h2>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Solutionether;
